// extracted by mini-css-extract-plugin
export var container = "_2w-0";
export var disabled = "_2w-3";
export var enabled = "_2w-2";
export var statusLight = "_2w-1";